// extracted by mini-css-extract-plugin
export default {"tooltipEnergyTariff":"EnergyTariffTooltip_tooltipEnergyTariff__BhQqA"};